import { useState, useEffect } from 'react';
import { rateCreationConstraints } from '../Services/Offer.service';

/**
 * Custom hook that fetches rate creation constraints from the API.
 * Replaces the duplicated useState + useEffect pattern across multiple components.
 *
 * @param {boolean} enabled - Whether to fetch (default: true).
 *                            Pass a condition like `open` for conditionally-loaded components.
 * @returns {object|null} The constraints data, or null if not yet loaded.
 */
export function useRateConstraints(enabled = true) {
  const [constraints, setConstraints] = useState(null);

  useEffect(() => {
    if (!enabled) return;
    rateCreationConstraints()
      .then((res) => setConstraints(res?.data ?? null))
      .catch(console.error);
  }, [enabled]);

  return constraints;
}

/**
 * Validates a "Per Km Charge" value against the ADDNL_PER_KM_CHARGE constraint.
 * Works with both react-hook-form `validate` callbacks and manual if-else validation.
 *
 * @param {string|number} value - The field value to validate
 * @param {object|null} constraints - The constraints object from useRateConstraints()
 * @returns {string|true} - Error message string, or `true` if valid
 */
export function validatePerKmCharge(value, constraints) {
  if (constraints?.ADDNL_PER_KM_CHARGE &&
      Number(value) <= Number(constraints.ADDNL_PER_KM_CHARGE)) {
    return `Per Km Charge must be greater than ${constraints.ADDNL_PER_KM_CHARGE}`;
  }
  return true;
}